export const OPS_PAPERWORK_TABS = [
  "deals",
  "locations",
  "payables",
  "books",
  "tasks",
  "notifications",
  "oversight",
  "settings",
  "timeline",
] as const;

export type OpsPaperworkTab = (typeof OPS_PAPERWORK_TABS)[number];

export const OPS_PAPERWORK_TAB_LABELS: Record<OpsPaperworkTab, string> = {
  deals: "Deals",
  locations: "Locations",
  payables: "Payables",
  books: "Books",
  tasks: "Tasks",
  notifications: "Notifications",
  oversight: "Oversight",
  settings: "Settings",
  timeline: "Timeline",
};

export const OPS_MANAGE_TABS: OpsPaperworkTab[] = [
  "deals",
  "locations",
  "payables",
  "books",
  "tasks",
  "notifications",
  "oversight",
  "settings",
  "timeline",
];

export const OPS_SALES_SAFE_TABS: OpsPaperworkTab[] = ["tasks", "notifications"];

/** Post-acceptance review. Deal queue and timeline, without setup tabs. */
export const OPS_REVIEW_TABS: OpsPaperworkTab[] = [
  "deals",
  "timeline",
  "tasks",
  "notifications",
];

export function visibleOpsPaperworkTabs(access: {
  canManage: boolean;
  canReviewDeals: boolean;
}): OpsPaperworkTab[] {
  if (access.canManage) return [...OPS_MANAGE_TABS];
  if (access.canReviewDeals) return [...OPS_REVIEW_TABS];
  return [...OPS_SALES_SAFE_TABS];
}

export function opsPaperworkTabAllowed(
  tab: OpsPaperworkTab,
  access: { canManage: boolean; canReviewDeals: boolean },
): boolean {
  return visibleOpsPaperworkTabs(access).includes(tab);
}

export function opsPaperworkTabLabel(tab: OpsPaperworkTab): string {
  return OPS_PAPERWORK_TAB_LABELS[tab];
}

export function isOpsManageOnlyTab(tab: OpsPaperworkTab): boolean {
  return tab !== "tasks" && tab !== "notifications";
}
